import Vue from "vue";
import Router from "vue-router";
import Index from "../containers/Index";
import AllEvents from "../containers/AllEvents";
import NewsPost from "../containers/NewsPost";
import AllProjects from "../containers/AllProjects";
import ProjectPage from "../containers/ProjectPage";
import AllPlaces from "../containers/AllPlaces";
import Library from "../containers/Library";
import LibraryAlbumPage from "../containers/LibraryAlbumPage";
import LibraryBookPage from "../containers/LibraryBookPage";
import PlacePage from "../containers/PlacePage";
import PostFeedback from "../containers/PostFeedback";
import ForumPage from "../containers/ForumPage";
// import AboutDistrictBook from "../containers/AboutDistrictBook";
// import AboutVillagesBook from "../containers/AboutVillagesBook";
import NotFound from "../containers/NotFound";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [
		{
			path: "/",
			component: Index,
			meta: {
				title: "Главная страница"
			}
		},
		{
			path: "/events",
			component: AllEvents,
			meta: {
				title: "Все события"
			}
		},
		{
			path: "/events/:eventId",
			component: NewsPost,
			meta: {
				title: "Событие"
			}
		},
		{
			path: "/projects",
			component: AllProjects,
			meta: {
				title: "Все проекты"
			}
		},
		{
			path: "/projects/:projectId",
			component: ProjectPage,
			meta: {
				title: "Проект"
			}
		},
		{
			path: "/places",
			component: AllPlaces,
			meta: {
				title: "Все места"
			}
		},
		{
			path: "/places/:placeId",
			component: PlacePage,
			meta: {
				title: "Место"
			}
		},
		{
			path: "/feedback",
			component: PostFeedback,
			meta: {
				title: "Оставить обращение"
			}
		},
		{
			path: "/library",
			component: Library,
			meta: {
				title: "Библеотека"
			}
		},
		{
			path: "/library/books/",
			redirect: '/library#books'
		},
		{
			path: "/library/books/:bookId/",
			redirect: '/library/books/:bookId/1'
		},
		{
			path: "/library/books/:bookId/:chapterId",
			component: LibraryBookPage,
			meta: {
				title: "Библиотека"
			}
		},
		{
			path: "/library/albums",
			redirect: '/library#albums'
		},
		{
			path: "/library/albums/:albumId",
			component: LibraryAlbumPage,
			meta: {
				title: "Фотоальбом"
			}
		},
		{
			path: "/forum",
			component: ForumPage,
			meta: {
				title: "Форум"
			}
		},
		{
			path: "*",
			component: NotFound,
			meta: {
				title: "Страница не найдена"
			}
		}
	],
	scrollBehavior (to, from, savedPosition) {
		if (to.matched.some(m => m.meta.disableScroll)) return;
		return ({x: 0, y: 0})
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js